import { render, staticRenderFns } from "./RowStandard.vue?vue&type=template&id=63f0b4d5&scoped=true"
import script from "./RowStandard.vue?vue&type=script&lang=js"
export * from "./RowStandard.vue?vue&type=script&lang=js"
import style0 from "./RowStandard.vue?vue&type=style&index=0&id=63f0b4d5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f0b4d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63f0b4d5')) {
      api.createRecord('63f0b4d5', component.options)
    } else {
      api.reload('63f0b4d5', component.options)
    }
    module.hot.accept("./RowStandard.vue?vue&type=template&id=63f0b4d5&scoped=true", function () {
      api.rerender('63f0b4d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/umesr/components/RowStandard.vue"
export default component.exports